interface IDeleteProps extends React.SVGProps<SVGSVGElement> {
  className?: string
  color?: string
  style?: React.CSSProperties
}

export const DeleteIcon = ({ color = 'currentColor', ...rest }: IDeleteProps) => {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...rest}>
      <rect width='24' height='24' rx='5' fill={color} />
      <path
        d='M5.77778 19.2C5.77778 19.6774 5.96508 20.1352 6.29848 20.4728C6.63187 20.8104 7.08406 21 7.55556 21H16.4444C16.9159 21 17.3681 20.8104 17.7015 20.4728C18.0349 20.1352 18.2222 19.6774 18.2222 19.2V8.4H20V6.6H16.4444V4.8C16.4444 4.32261 16.2571 3.86477 15.9237 3.52721C15.5903 3.18964 15.1382 3 14.6667 3H9.33333C8.86184 3 8.40965 3.18964 8.07625 3.52721C7.74286 3.86477 7.55556 4.32261 7.55556 4.8V6.6H4V8.4H5.77778V19.2ZM9.33333 4.8H14.6667V6.6H9.33333V4.8ZM8.44444 8.4H16.4444V19.2H7.55556V8.4H8.44444Z'
        fill='#EA3A3D'
      />
      <path d='M9.5 10.333H11.1667V16.9997H9.5V10.333ZM12.8333 10.333H14.5V16.9997H12.8333V10.333Z' fill='#EA3A3D' />
    </svg>
  )
}
